import React, { ReactNode } from "react";
interface DividerProps {
  bgColor?: string;
}
const BlueHorizontalDivider: React.FC<DividerProps> = ({
  bgColor = "#B9DEF7", // default color
}) => {
  return (
    <div
      style={{
        height: "3px",
        backgroundColor: bgColor,
        width: "100%",
      }}
    />
  );
};


export default BlueHorizontalDivider;
